// Schema de la tabla `tenants`. Multi-tenant: cada cliente de Jidoka tiene su
// propio tenant. El cliente ancla del MVP es UPG; Alpina es CLIENTE de UPG (otra
// entidad — ver `clientes` table, no esta).
import { z } from 'zod';
export const atribucionTurnoCruceSchema = z.enum(['dia_inicio', 'dia_fin']);
// El campo `plan` queda como string libre hasta que se definan tiers comerciales
// concretos. Cuando se cierre el modelo de pricing, se reemplaza por z.enum.
// (No se infiere prematuramente desde el spec — diferido sin decisión técnica).
export const tenantSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string().trim().min(1).max(120),
    nit: z.string().trim().min(5).max(30),
    logo_url: z.string().url().nullable(),
    contacto_email: z.string().email().toLowerCase().trim(),
    plan: z.string().trim().min(1).max(40),
    activo: z.boolean(),
    timezone: z.string().trim().min(1),
    atribucion_turno_cruce: atribucionTurnoCruceSchema,
    dia_inicio_semana: z.number().int().min(1).max(7),
    created_at: z.string().datetime({ offset: true }),
});
/** Payload para crear un tenant (Super Admin, pantalla SA3 onboarding wizard). */
export const tenantCreateSchema = tenantSchema
    .pick({
    nombre: true,
    nit: true,
    contacto_email: true,
    plan: true,
})
    .extend({
    logo_url: z.string().url().nullable().optional(),
});
/** Payload de actualización de tenant (todos los campos opcionales). */
export const tenantUpdateSchema = tenantSchema
    .pick({
    nombre: true,
    nit: true,
    logo_url: true,
    contacto_email: true,
    plan: true,
    timezone: true,
    atribucion_turno_cruce: true,
    dia_inicio_semana: true,
})
    .partial();
//# sourceMappingURL=tenant.js.map